import { gql } from '@apollo/client'

export default gql`
  fragment LibraryPostArticleBlockComponent on LibraryPostArticle {
    id
    slug
    type
    title
    image {
      url
      blurhash
    }
    imageSquare {
      url
      blurhash
    }
    topics {
      nodes {
        id
        slug
        title
      }
    }
    description
  }
`
